import {ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef} from '@angular/core';

import {LinkComponent} from "../link/link.component";

@Component({
    selector: 'app-error',
    imports: [
        LinkComponent
    ],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {
  public message: InputSignal<string> = input<string>('');
  public linkText: InputSignal<string> = input<string>('');
  public emitClickOnWholeElement: InputSignal<boolean> = input<boolean>(false);
  // eslint-disable-next-line @angular-eslint/no-output-native
  public click: OutputEmitterRef<void> = output<void>();

  public selected(event: Event): void {
    event.stopPropagation();
    this.click.emit();
  }

  public outerSelected(event: Event): void {
    if (this.emitClickOnWholeElement()) {
      this.selected(event);
    }
  }
}
